import MetaRobots from 'components/Basic/Head/MetaRobots';
import SortingBar from 'components/Blocks/SortingBar/SortingBar';
import { Webline } from 'components/Layout/Webline/Webline';
import { FlagDetailProductsWrapper } from 'components/Pages/FlagDetail/FlagDetailProductsWrapper';
import { SORT_QUERY_PARAMETER_NAME } from 'config/constants';
import { useSeoTitleWithPagination } from 'helpers/seo/useSeoTitleWithPagination';
import { useRouter } from 'next/router';
import { useRef } from 'react';
import { FlagDetailType } from 'types/flag';

type FlagDetailProps = {
    flag: FlagDetailType;
};

const FlagDetail: FC<FlagDetailProps> = ({ flag }) => {
    const router = useRouter();
    const isSorted = SORT_QUERY_PARAMETER_NAME in router.query;
    const paginationScrollTargetRef = useRef<null | HTMLDivElement>(null);
    const seoTitle = useSeoTitleWithPagination(flag.productConnection.totalCount, flag.name);

    return (
        <>
            {isSorted && <MetaRobots content="noindex, follow" />}
            <Webline>
                <h1 data-testid="basic-heading-h1">{seoTitle}</h1>
            </Webline>
            <Webline>
                <div ref={paginationScrollTargetRef}>
                    <SortingBar
                        sorting={flag.productConnection.orderingMode}
                        totalCount={flag.productConnection.totalCount}
                    />
                    <FlagDetailProductsWrapper flag={flag} paginationScrollTargetRef={paginationScrollTargetRef} />
                </div>
            </Webline>
        </>
    );
};

export default FlagDetail;
